/* Fit Craver — social proof (bq-proof.js)
   Added 2026-09-05. Plan Part 4.4.

   ------------------------------------------------------------------
   WHERE THESE NUMBERS COME FROM — read before changing them.

   They are CROSS-CHANNEL totals supplied by the merchant on 2026-09-05,
   covering WhatsApp and Instagram DM orders that never pass through
   Shopify. They are deliberately higher than Shopify's own counts:

     product     merchant total   Shopify orders (all time)
     Colombian        5,600            1,113      (~5x)
     Brazilian        2,700              563      (~5x)
     French           3,000               77     (~39x)  <-- see note

   NOTE ON THE FRENCH FIGURE: it does not follow the same ratio as the
   other two, and it would make the French nearly as popular as the
   Brazilian, which outsells it 7:1 on-site. Flagged to the merchant
   2026-09-05. Revise here if it turns out to be wrong.

   RULE FOR FUTURE EDITS: only ever put a number here that could be
   backed up — courier shipment totals are the best source, because they
   count every channel. This store is 100% cash on delivery, so a claim
   that cannot be supported is checked at the customer's door, and the
   parcel simply comes back at your cost.
   ------------------------------------------------------------------
*/
(function () {
  'use strict';

  var HE = (document.documentElement.lang || '').indexOf('he') === 0;

  /* product id -> count to display */
  var COUNTS = {
    '7371483578502': '5,600',   /* المشد الكولومبي  */
    '7371483644038': '2,700',   /* المشد البرازيلي */
    '7371483906182': '3,000'    /* مشد العود الفرنسي */
  };

  function text(n) {
    return HE
      ? '⭐ יותר מ-' + n + ' נשים כבר הזמינו את המחטב הזה'
      : '⭐ أكثر من ' + n + ' سيدة طلبت هذا المشد';
  }

  function getProductId() {
    var el = document.querySelector('[data-productid]');
    return el ? el.getAttribute('data-productid') : null;
  }

  function init() {
    if (document.querySelector('.bq-proof')) return;
    var n = COUNTS[getProductId()];
    if (!n) return;

    /* sit it directly under the price, where she is deciding */
    var price = document.querySelector('.t4s-product__price');
    if (!price || !price.parentNode) return;

    var el = document.createElement('div');
    el.className = 'bq-proof';
    el.textContent = text(n);
    price.parentNode.insertBefore(el, price.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
